module.exports = __webpack_public_path__ + "media/images/icon-question@3x-6f2784f66b333c275ba8d796ff2bdca2.png";